import { render } from "./turma_add_aluno.vue?vue&type=template&id=042057b2&scoped=true"
import script from "./turma_add_aluno.vue?vue&type=script&lang=js"
export * from "./turma_add_aluno.vue?vue&type=script&lang=js"

import "./turma_add_aluno.vue?vue&type=style&index=0&id=042057b2&lang=css"
import "./turma_add_aluno.vue?vue&type=style&index=1&id=042057b2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042057b2"]])

export default __exports__